import { Link } from "react-router-dom";
import { comicApps } from "@/mocks/apps";
import Rating from "@/components/base/Rating";

export default function TopRanking() {
  const top = comicApps.slice(0, 3);
  const medal = ["bg-secondary-500", "bg-background-400", "bg-primary-500"];

  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">热门漫画软件应用排行 TOP 3</h2>
            <p className="mt-2 text-sm text-foreground-600">综合评分、资源数量、更新速度与口碑得出的榜单，供你快速决策</p>
          </div>
          <Link to="/rankings" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-600 transition-colors hover:text-primary-700">
            查看完整榜单
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {top.map((app, i) => (
            <article key={app.id} className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-100 transition-transform duration-300 hover:-translate-y-1">
              <Link to={`/reviews/${app.id}`} className="relative block overflow-hidden">
                <div className="aspect-[16/10] w-full overflow-hidden bg-background-200">
                  <img
                    src={app.cover}
                    alt={`${app.name}排行第${i + 1}名`}
                    title={`${app.name}漫画软件应用排行第${i + 1}名`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <span className={`absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-full ${medal[i]} text-lg font-black text-background-50`}>
                  {i + 1}
                </span>
              </Link>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="text-lg font-bold text-foreground-950">
                    <Link to={`/reviews/${app.id}`} className="transition-colors hover:text-primary-600">{app.name}</Link>
                  </h3>
                  <span className="flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-2 py-0.5 text-sm font-black text-background-50">
                    {app.score} 分
                  </span>
                </div>
                <p className="mt-0.5 text-xs text-foreground-600">{app.tagline}</p>
                <div className="mt-2 flex items-center justify-between">
                  <Rating value={app.rating} />
                  <span className="text-xs text-foreground-500">{app.price}</span>
                </div>
                <p className="mt-3 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-700">{app.summary}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {app.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">{tag}</span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}